import { useContext } from 'react';

import type { NewsItemContextType } from '../../contexts/news-item-context/news-item-context';
import { NewsItemContext } from '../../contexts/news-item-context/news-item-context';

export const useNewsItemContext = (): NewsItemContextType => {
  const context = useContext(NewsItemContext);

  if (!context) {
    throw new Error(
      'useNewsItemContext must be used within a NewsItemContextProvider'
    );
  }

  return context;
};
